let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3kQkj")).then(() => parcelRequire('5yA7f'));